import script from "./AllGamesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AllGamesPage.vue?vue&type=script&setup=true&lang=js"

import "./AllGamesPage.vue?vue&type=style&index=0&id=9e4d8410&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e4d8410"]])

export default __exports__